// extracted by mini-css-extract-plugin
export default {"innerWrapper":"dt-z","tooltipWrapper":"et-z","icon":"ft-z","tooltip":"gt-z","content":"ht-z"};